export const ROUTES = {
    HOME: {
        path: '/',
        name: 'home',
        title: 'ホーム',
        icon: 'HomeIcon',
    },
    USER: {
        path: '/admin',
        name: 'admin',
        title: '管理者メニュー',
        icon: 'UserIcon',
    },
    ACCOUNT_SETTINGS: {
        // 各ユーザが確認できるユーザ情報
        path: '/account/settings',
        name: 'account-settings',
        title: 'アカウント設定',
        icon: 'SettingsIcon',
    },
    FORGOT_PASSWORD: {
        path: '/forgot-password',
        name: 'forgot-password',
        title: 'パスワードを忘れた場合',
        icon: '',
    },
    RESET_PASSWORD: {
        path: '/reset-password',
        name: 'reset-password',
        title: 'パスワードをリセット',
        icon: '',
    },
    USER_SETTINGS: {
        // admin側で見ることができるユーザ情報
        path: '/user/settings',
        name: 'user-settings',
        title: 'ユーザ設定',
        icon: 'SettingsIcon',
    },
    INVITE: {
        path: '/user/invite',
        name: 'invite',
        title: 'メンバー招待',
        icon: 'UserPlusIcon',
    },
    LIST: {
        path: '/user/list',
        name: 'list',
        title: 'メンバー一覧',
        icon: 'UsersIcon',
    },
    LOGIN: {
        path: '/login',
        name: 'auth-login',
        title: 'ログイン',
        icon: '',
    },
    LOGOUT: {
        path: '/logout',
        name: 'auth-logout',
        title: 'ログアウト',
        icon: 'LogOutIcon',
    },
    REGISTER: {
        path: '/register',
        name: 'register',
        title: '新規ユーザ登録',
        icon: 'UserIcon',
    },
    COMPASS: {
        path: '/light-compass',
        name: 'compass',
        title: 'ライトコンパス',
        icon: 'CompassIcon',
    },
    FREE_COMPASS: {
        path: '/free/light-compass',
        name: 'free_compass',
        title: '無料版ライトコンパス',
        icon: 'CompassIcon',
    },
    PUBLIC_LIGHT_COMPASS: {
        path: '/light-compass2026',
        name: 'public_light_compass',
        title: 'ライトコンパス（公開）',
        icon: 'CompassIcon',
    },
    MASTERCHART: {
        path: '/soul-code',
        name: 'masterchart',
        title: 'ソウルコード',
        icon: 'PieChartIcon',
    },
    PASSPORT: {
        path: '/passport',
        name: 'passport',
        title: 'パスポート',
        icon: 'KeyIcon',
    },
    PUBLIC_PASSPORT: {
        path: '/passport2026',
        name: 'public_passport',
        title: 'パスポート（公開）',
        icon: 'KeyIcon',
    },
    /**
     * 途中まで作成した公開パスポート。ライトコンパスのリンク先 `/passport2026` は工事中のまま。
     */
    PUBLIC_PASSPORT_PREVIEW: {
        path: '/passport2026/preview',
        name: 'public_passport_preview',
        title: 'パスポート（作成途中）',
        icon: 'KeyIcon',
    },
    PUBLIC_PASSPORT_PRINT: {
        path: '/v2/passport/print',
        name: 'public_passport_print',
        title: 'パスポート PDF 印刷',
        icon: 'KeyIcon',
    },
    YEAR_FORTUNE: {
        path: '/fortune',
        name: 'fortune',
        title: '今年の運勢',
        icon: 'CalendarIcon',
    },
    NON_AUTH: {
        path: '/non-authorized',
        name: 'nonAuth',
        title: '',
        icon: '',
    },
    ERROR: {
        path: '/error-404',
        name: 'error',
        title: '',
        icon: '',
    },
}
